"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.steamEndpointIds = void 0;
exports.steamEndpointIds = {
    SAVE_STEAM_USER_INFO: 'SAVE_STEAM_USER_INFO',
};
